module.exports = __webpack_public_path__ + "img/up_res_database.a5ca9ace.svg";